import { FC } from "react";

import __ from "web/Layout/Translations";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import WcagTooltipWrapper from "web/Components/Common/ToolTip/wcagTooltipWrapper";
import defaultClasses from "./subscriptionDefinition.scss";

interface ISubscriptionLegendDefinitionProps {
  id?: string;
  message: string;
  children: any;
  isWCAG?: boolean;
}

const SubscriptionLegendDefinition: FC<
  PropsWithClasses<ISubscriptionLegendDefinitionProps>
> = ({ classes = {}, id = "tooltip-id", message, isWCAG = false, children }) => {
  return isWCAG ? (
    <WcagTooltipWrapper
      renderTrigger={({ isOpen, ...triggerProps }) => (
        <button
          type="button"
          className={`${classes.root || defaultClasses.root} ${
            defaultClasses.rootWCAG
          }`}
          aria-describedby={isOpen ? id : undefined}
          aria-expanded={isOpen}
          aria-label={__(message)}
          {...triggerProps}
        >
          {children}
          <div
            id={id}
            role="tooltip"
            className={`${classes.tooltip || defaultClasses.tooltip} ${
              isOpen ? defaultClasses.isVisible : ""
            }`}
          >
            {__(message)}
          </div>
        </button>
      )}
      renderTooltip={() => null}
    />
  ) : (
    <div className={classes.root}>
      {children}
      <div className={classes.tooltip} role="tooltip">{__(message)}</div>
    </div>
  );
};

export default classify<PropsWithClasses<ISubscriptionLegendDefinitionProps>>(
  defaultClasses
)(SubscriptionLegendDefinition);
